module.exports = __webpack_public_path__ + "static/media/logo.9fb2b1fd.png";